import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { SeoLayout } from '@/components/astro/new-design-25/SEO/seo-layout';
import { seo } from '@/seo/seo';

const heroTitle = 'Text to Speech for Students';
const heroDescription =
  'Student-focused text to speech tools for academic success. Listen to textbooks, research papers, and study materials to improve comprehension and retention.';

const featureTitle = heroTitle;
const featureSubtitle = 'Academic audio learning';
const featureDescription = heroDescription;
const featureBadge = 'Student Tools';
const featureVariant = 'default';
const featureCtaText = 'Boost Study Performance';

const featureFeatures = [
  {
    title: 'Textbook Audio Conversion',
    description:
      'Convert academic textbooks and course materials into audio for flexible study sessions.',
  },
  {
    title: 'Research Paper Listening',
    description:
      'Listen to scientific papers and academic articles while taking notes or doing other tasks.',
  },
  {
    title: 'Improved Retention',
    description:
      'Studies show audio learning can improve information retention and comprehension rates.',
  },
];

export const Route = createFileRoute(
  '/_marketing/_seo/text-to-speech-for-students',
)({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'Text to Speech for Students - Academic Audio Learning Tools | Listening',
        description:
          'Text to speech tools designed for students. Convert textbooks and research papers to audio. Improve study efficiency and academic performance.',
      }),
    ],
  }),
  component: () => (
    <SeoLayout
      featureBadge={featureBadge}
      featureCtaText={featureCtaText}
      featureDescription={featureDescription}
      featureFeatures={featureFeatures}
      featureSubtitle={featureSubtitle}
      featureTitle={featureTitle}
      featureVariant={featureVariant}
      pageDescription={heroDescription}
      pageTitle={heroTitle}
    />
  ),
});
